module.exports = __webpack_public_path__ + "img/img22.01d272fa.png";